import { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { cancelSingleAppointment } from "../../store/appointment/appointmentActions";
import { Controller, useForm } from "react-hook-form";

import ReactSelect from "react-select";
import { ProfileRole } from "../../store/profile/profileSlice";

const CancelEvent = ({ setIsCancel, event, refreshParent }) => {

    const dispatch = useDispatch();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { handleSubmit, control, register, watch } = useForm()

    const handleCancel = (data) => {
        setIsSubmitting(true);
        dispatch(cancelSingleAppointment({ id: data._id, reason: data.reason.label, message: data.message }))
            .unwrap()
            .then(v => refreshParent())
            .finally(() => setIsSubmitting(false))
    }

    const {currentProfile} = useSelector(state => state.profile)
    const IssueOptions = [
        ...(currentProfile.role == ProfileRole.TUTOR ? [
            { value: 1, label: "Health issues" },
            { value: 2, label: "I am taking leave" },
            { value: 3, label: "I wish to change my rates" },
            { value: 4, label: "I have another commitment" },
            { value: 5, label: "I have a technical problem" },
            { value: 6, label: "Other" },
        ]
            : currentProfile.role == ProfileRole.STUDENT ?
                [
                    { value: 1, label: "Health issues" },
                    { value: 4, label: "I have another commitment" },
                    { value: 5, label: "I have a technical problem" },
                    { value: 6, label: "Other" },
                ]
                : []
        )
    ]

    const reasonValue = watch("reason");
    const messageValue = watch("message");
    const canSubmit = Boolean(reasonValue) && !isSubmitting;

    const selectStyles = useMemo(() => ({
        control: (base, state) => ({
            ...base,
            minHeight: "44px",
            borderColor: state.isFocused ? "#191D51" : "#d9dde5",
            boxShadow: state.isFocused ? "0 0 0 1px #191D51" : "none",
            borderRadius: "12px",
            "&:hover": { borderColor: "#191D51" },
        }),
        menu: (base) => ({
            ...base,
            borderRadius: "12px",
            overflow: "hidden",
            zIndex: 9999,
        }),
        menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    }), []);

    return <div className="mx-5 mb-5 rounded-2xl border border-nt-grey-light bg-white shadow-sm">
        <form className="flex flex-col gap-5 p-5" onSubmit={handleSubmit((data) => handleCancel(data))}>
            <div className="border-b border-nt-grey-light pb-4">
                <h3 className="text-nt-blue text-lg font-semibold">Cancel Course</h3>
                <p className="text-sm text-nt-grey mt-1">
                    Select a reason so we can keep your appointment history clear.
                </p>
            </div>
            <div className="flex">
                <div className="w-full">
                    <label className="text-xs font-semibold uppercase tracking-wide text-nt-grey mb-2 block">Reason</label>
                    <Controller
                        control={control}
                        name="reason"
                        render={({ field: { onChange, value } }) => (
                            <ReactSelect
                                className="w-full"
                                placeholder="Reason"
                                onChange={onChange}
                                value={value || ''}
                                options={IssueOptions}
                                styles={selectStyles}
                                menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                                menuPosition="fixed"
                            />
                        )}
                    />
                    <input name="_id" {...register("_id")} type="hidden" value={event._id} />
                    <label className="text-xs font-semibold uppercase tracking-wide text-nt-grey mt-4 mb-2 block">Message (optional)</label>
                    <textarea
                        name="message"
                        {...register("message")}
                        rows={4}
                        className="w-full border border-nt-grey-light focus:border-nt-blue focus:ring-1 focus:ring-nt-blue rounded-xl p-3 text-sm"
                        placeholder="Add extra details (optional)..."
                    ></textarea>
                </div>
            </div>
            <div className="flex justify-end gap-3 border-t border-nt-grey-light pt-4">
                <button
                    type="button"
                    className="w-32 bg-nt-grey text-white px-2 py-2.5 rounded-xl hover:opacity-90 transition"
                    onClick={() => setIsCancel(false)}
                    disabled={isSubmitting}
                >
                    Back
                </button>
                <button
                    className={`w-40 text-white px-2 py-2.5 rounded-xl transition ${canSubmit ? "bg-nt-red hover:opacity-90" : "bg-nt-grey opacity-70 cursor-not-allowed"}`}
                    disabled={!canSubmit}
                >
                    {isSubmitting ? "Cancelling..." : "Cancel Course"}
                </button>
            </div>
        </form>
    </div>
}
export { CancelEvent }